module.exports = __webpack_public_path__ + "img/shopping-cart.492a53ba.svg";